import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store/main';
import { Speaker } from '@/types/speakers.types';

export const selectIsLoadingSpeakers = (state: RootState) =>
  state.speakers.speakers.loading && state.speakers.speakers.page === 0;

export const selectSpeakerState = (state: RootState) => state.speakers.speakers;
export const selectSpeakersById = (state: RootState) => state.speakers.speakersById;

export const selectSpeakerOptionsState = (search: string) =>
  createSelector(
    [selectSpeakersById, selectSpeakerState, (state: RootState) => state.speakers.searchedSpeakers],
    (speakersById, speakers, searchState) => {
      const list = search ? searchState : speakers;
      return {
        speakers: list.ids.map((id) => speakersById[id]).filter((speaker: Speaker | null) => !!speaker),
        loading: list.loading,
        hasMore: list.total === null || list.ids.length < list.total,
        page: list.page,
      };
    }
  );
